import {
  CriApiResponse,
  GETInstrumentosFilterParams,
  CadastroCriApiRequest,
  SolicitarLiquidacaoRequest,
  HistoricoResponse,
  CommandResultTyped,
} from 'common/genericTypes';
import { Dispatch } from 'redux';
import {
  GETCriDetalhes,
  GETCris,
  POSTCri,
  PUTCri,
  GETCriDocumentDownloadUrl,
  POSTInterOpCri,
  POSTEnviarLiquidacao,
  GETHistoricoCri,
  POSTConfirmarLiquidacaoCri,
  PUTUploadDoc as PUTUploadDocCri,
  DELETEUploadDoc as DELETEUploadDocCri,
  GETCriByInstrumentoId,
  PUTCriAditamento,
  PutEditarCri,
  GETAditamentoCri,
  PUTAditamentoCri,
} from 'requests/cri';
import { UploadDocResponse } from '../models/uploadDocResponse';
import { typedAction } from 'store/modules/base';
import { AditamentoDiferenca, AditamentoRevisionData } from 'components/aditamentoModal/aditamentoRevisionModal';

export interface CriApiState {
  getCriDetalhes(dispatch: Dispatch, id: string, stackRequest?: boolean): Promise<CriApiResponse>;
  getCris(
    dispatch: Dispatch,
    params?: GETInstrumentosFilterParams,
    stackRequest?: boolean
  ): Promise<Array<CriApiResponse>>;
  getCriByInstrumentoId(dispatch: Dispatch, instrumentoId: string, stackRequest?: boolean): Promise<CriApiResponse>;
  postCri(dispatch: Dispatch, cri: CadastroCriApiRequest, stackRequest?: boolean): Promise<CriApiResponse>;
  putCri(
    dispatch: Dispatch,
    criId: string,
    cri: CadastroCriApiRequest,
    stackRequest?: boolean
  ): Promise<CriApiResponse>;
  putCriAditamento(
    dispatch: Dispatch,
    criId: string,
    cri: CadastroCriApiRequest,
    date: string,
    document: File,
    stackRequest?: boolean
  ): Promise<string>;
  putEditarCri(
    dispatch: Dispatch,
    criId: string,
    cri: CadastroCriApiRequest,
    justificativa: string,
    document?: File | undefined,
    stackRequest?: boolean
  ): Promise<CommandResultTyped<string>>;
  putUploadDoc(
    dispatch: Dispatch,
    criId: string,
    emissionType: string,
    file: File,
    stackRequest?: boolean
  ): Promise<Array<UploadDocResponse>>;
  deleteUploadDoc(dispatch: Dispatch, criId: string, criDocumentId: string, stackRequest?: boolean): Promise<unknown>;
  getCriDocumentDownloadUrl(
    dispatch: Dispatch,
    criId: string,
    criDocumentId: string,
    stackRequest?: boolean
  ): Promise<string>;
  postInterOpCri(dispatch: Dispatch, cri: CadastroCriApiRequest, stackRequest?: boolean): Promise<CriApiResponse>;
  postEnviarLiquidacao(
    dispatch: Dispatch,
    criId: string,
    criSolicitarLiquidacaoRequest: SolicitarLiquidacaoRequest,
    stackRequest?: boolean
  ): Promise<CriApiResponse>;
  postConfirmarLiquidacaoCri(dispatch: Dispatch, criId: string, precoUnitarioLiquidacao: number, stackRequest?: boolean): Promise<CriApiResponse>;
  getHistoricoCri(dispatch: Dispatch, criId: string, stackRequest?: boolean): Promise<Array<HistoricoResponse>>;
  getAditamentoCri(dispatch: Dispatch, aditamentoId: string, stackRequest?: boolean): Promise<AditamentoRevisionData>;
  putAditamentoCri(dispatch: Dispatch, aditamentoId: string, diferenca: AditamentoDiferenca[], stackRequest?: boolean): Promise<Array<AditamentoDiferenca>>;
}

export const criApiInicialState: CriApiState = {
  getCriDetalhes: GETCriDetalhes,
  getCris: GETCris,
  getCriByInstrumentoId: GETCriByInstrumentoId,
  postCri: POSTCri,
  putCri: PUTCri,
  putCriAditamento: PUTCriAditamento,
  putEditarCri: PutEditarCri,
  putUploadDoc: PUTUploadDocCri,
  deleteUploadDoc: DELETEUploadDocCri,
  getCriDocumentDownloadUrl: GETCriDocumentDownloadUrl,
  postInterOpCri: POSTInterOpCri,
  postEnviarLiquidacao: POSTEnviarLiquidacao,
  postConfirmarLiquidacaoCri: POSTConfirmarLiquidacaoCri,
  getHistoricoCri: GETHistoricoCri,
  getAditamentoCri: GETAditamentoCri,
  putAditamentoCri: PUTAditamentoCri,
};

enum CriApiActionType {
  Update = 'criApi/UPDATE',
  Reset = 'criApi/RESET',
}

export const updateCriApi = (state: CriApiState) => {
  return typedAction(CriApiActionType.Update, state);
};

export const resetCriApi = () => {
  return typedAction(CriApiActionType.Reset);
};

type CriApiAction = ReturnType<typeof updateCriApi | typeof resetCriApi>;

export function criApiReducer(state: CriApiState = criApiInicialState, action: CriApiAction): CriApiState {
  switch (action.type) {
    case CriApiActionType.Update:
      return { ...action.payload };
    case CriApiActionType.Reset:
      return { ...criApiInicialState };
    default:
      return state;
  }
}
